/* assets/sst-faq.js */

class SstFaq {
    constructor(container) {
        this.container = container;
        this.groups = this.container.querySelectorAll('.sst-faq-group');
        this.items = this.container.querySelectorAll('.sst-faq-item');

        this.init();
    }

    init() {
        // Init Category Groups
        this.groups.forEach(group => {
            const toggle = group.querySelector('.sst-faq-group-toggle');
            if (toggle) {
                toggle.addEventListener('click', () => this.toggleGroup(group));
                
                // If active by default (Liquid), ensure height is set
                if (group.classList.contains('active')) {
                    this.openGroup(group, true); // true = immediate, no transition
                }
            }
        });

        // Init individual FAQ Items
        this.items.forEach(item => {
            const toggle = item.querySelector('.sst-faq-toggle');
            if (toggle) {
                toggle.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.toggleItem(item);
                });
            }
        });
    }

    toggleGroup(activeGroup) {
        const isActive = activeGroup.classList.contains('active');

        // Close all other groups
        this.groups.forEach(group => {
            if (group !== activeGroup && group.classList.contains('active')) {
                this.closeGroup(group);
            }
        });

        if (isActive) {
            this.closeGroup(activeGroup);
        } else {
            this.openGroup(activeGroup);
        }
    }

    openGroup(group, immediate = false) {
        group.classList.add('active');
        const content = group.querySelector('.sst-faq-group-content');
        if (!content) return;

        if (immediate) {
            content.style.maxHeight = 'none';
            return;
        }

        content.style.maxHeight = content.scrollHeight + 'px';
        
        const handleTransitionEnd = (e) => {
            if (e.propertyName === 'max-height' && group.classList.contains('active')) {
                content.style.maxHeight = 'none';
                content.removeEventListener('transitionend', handleTransitionEnd);
            }
        };
        content.addEventListener('transitionend', handleTransitionEnd);
    }

    closeGroup(group) {
        group.classList.remove('active');
        const content = group.querySelector('.sst-faq-group-content');
        if (!content) return;

        if (content.style.maxHeight === 'none') {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
        
        // Force reflow
        content.offsetHeight;
        content.style.maxHeight = null;
    }

    toggleItem(activeItem) {
        const isActive = activeItem.classList.contains('active');

        // Close other items in the same group
        const parentContent = activeItem.closest('.sst-faq-group-content') || this.container;
        const brotherItems = parentContent.querySelectorAll('.sst-faq-item');
        
        brotherItems.forEach(item => {
            if (item !== activeItem && item.classList.contains('active')) {
                this.closeItem(item);
            }
        });

        if (isActive) {
            this.closeItem(activeItem);
        } else {
            this.openItem(activeItem);
        }
    }

    openItem(item) {
        item.classList.add('active');
        const content = item.querySelector('.sst-faq-content');
        if (content) {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    closeItem(item) {
        item.classList.remove('active');
        const content = item.querySelector('.sst-faq-content');
        if (content) {
            content.style.maxHeight = null;
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.sst-faq-section').forEach(section => {
        new SstFaq(section);
    });
});

// Re-initialize for Shopify Theme Editor
document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.sst-faq-section');
    if (section) new SstFaq(section);
});
